module.exports = __webpack_public_path__ + "img/contact.9a0e7cf5.png";